import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { UserNumber } from '@ragu-components/ord-types';

const PersonalUserNumbersList = React.lazy(async () => import('./PersonalUserNumbersList'));

export const personalUserNumbersResource: OrdResourceProps = {
  key: `me/${Resources.user_numbers}`,
  name: `me/${Resources.user_numbers}`,
  list: <PersonalUserNumbersList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: UserNumber): string =>
    record.description != null ? `${record.number} (${record.description})` : record.number,
};
